import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Item = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  justify-content: space-between;
  gap: 10px;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const Service = styled(Typography.Body)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Amount = styled(Typography.Body).attrs({ as: 'span' })`
  flex-shrink: 0;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Number = styled(Typography.Body)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Icons = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 10px;
`;

export const DownloadSlot = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
`;

export const Download = styled.a`
  display: flex;
  color: ${({ theme }) => theme.palette.secondary.labels};

  svg path {
    stroke: currentColor;
  }
`;

export const Chevron = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
